import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { buildTheme } from './theme';

/**
 * Wraps an admin island in the shared theme.
 *
 * ScopedCssBaseline rather than CssBaseline on purpose: CssBaseline resets the
 * whole document, which would reach out of the island and restyle the Bootstrap 3
 * page around it. Scoped applies MUI's baseline only inside this subtree, which is
 * the boundary that keeps the two frameworks from fighting.
 *
 * There is no colour or text-size picker any more -- see theme.js for why.
 */
const AdminTheme = ({ children }) => {
  const theme = useMemo(() => buildTheme(), []);

  return (
    <ThemeProvider theme={theme}>
      {/*
        The island must PAINT its own background, not inherit the page's. A
        transparent baseline looked fine in light mode and broke in dark: the
        theme's light text landed on the white Bootstrap page behind it, so the
        outlined step chips read as empty pills. Anything not sitting on a Paper had
        the same problem. `background.default` gives the island a canvas, and it
        reads as a panel inside the page -- which is what it is.
      */}
      <ScopedCssBaseline
        enableColorScheme
        sx={{
          bgcolor: 'background.default', color: 'text.primary', p: 2, borderRadius: 1,
        }}
      >
        {children}
      </ScopedCssBaseline>
    </ThemeProvider>
  );
};

AdminTheme.propTypes = { children: PropTypes.node };
AdminTheme.defaultProps = { children: null };

export default AdminTheme;
